import * as i18n from 'CMS/core/i18n';
import * as app from 'CMS/core/application';
import type { KnownValueMappers } from './Editors/IFilterEditor';
import { Search } from './SearchEditors/ISearchEditor';

export interface IFilterConfig {
    field: string;
    title: string;
    operator: string;
    permission: string;
    valueMapper: KnownValueMappers | string; // Note: uitbreidbaar met meerdere mappers door een pipeline mapper te maken en hier array van te maken
    editor: IFilterEditorConfig;
}

export interface ISearchConfig {    
    title: string;    
    permission: string;
    valueMapper: KnownValueMappers | string; // Note: uitbreidbaar met meerdere mappers door een pipeline mapper te maken en hier array van te maken
    search: 'text'
}

export interface IFilterEditorConfig {
    id: string;
    options?: any;
}

/**
 * Get the filters for the given type from the filters.json file
 * @param type
 */
export default async function getFilters(type: string, config: string): Promise<(IFilterConfig | ISearchConfig)[]> {
    if (type == null || type == '') {
        return [];
    }

    var jsonFile = 'filters/filters.json';
    if (config && config !== '') { jsonFile = 'filters/filters.' + config + '.json'; }

    const appData = await app.getAppData({ appName: 'AWFGrid', fileName: jsonFile });

    
    var allFilters = appData.data.filters;
    var filterOrders = appData.data.filterOrders;


    var filters: any[] = allFilters[type.toLowerCase()];
    if (filters == null) {
        filters = [];
    }

    for (let i = 0; i < filters.length; i++) {
        if ('editor' in filters[i]) {
            var editor = filters[i].editor;
            const filter = <IFilterConfig>filters[i];
            if (typeof editor === 'string' || editor instanceof String) {
                filter.editor = { id: <string>editor };
            }

            /* forced order  */
            if (filterOrders && filter.editor && filter.editor.options && filter.editor.options.order) {
                var filterOrderName = filter.editor.options.order;
                filter.editor.options.order = filterOrders[filterOrderName];
            }
        }         

        if (filters[i].title.indexOf('i18n!') === 0) { filters[i].title = i18n.getMessage(filters[i].title.substring('i18n!'.length)); }
    }

    return filters;
}


